import React from 'react';
import { Calendar, Download } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const AddToCalendar = () => {
  const { language } = useLanguage();
  const content = weddingData[language].countdown;

  const generateICS = () => {
    const event = {
      title: 'Mariage Nelly & Cyrille',
      description: 'Célébration du mariage de Cyrille NENIN et Nelly KACOU',
      location: 'Paroisse Sainte Cécile des 2 Plateaux Vallon, Abidjan, Côte d\'Ivoire',
      startDate: '20260814T140000',
      endDate: '20260815T000000',
    };

    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Nelly & Cyrille Wedding//FR',
      'BEGIN:VEVENT',
      `DTSTART:${event.startDate}`,
      `DTEND:${event.endDate}`,
      `SUMMARY:${event.title}`,
      `DESCRIPTION:${event.description}`,
      `LOCATION:${event.location}`,
      'STATUS:CONFIRMED',
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\n');

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'mariage-cyrille-nelly.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const addToGoogleCalendar = () => {
    const event = {
      title: 'Mariage Nelly & Cyrille',
      details: 'Célébration du mariage de Cyrille NENIN et Nelly KACOU',
      location: 'Paroisse Sainte Cécile des 2 Plateaux Vallon, Abidjan',
      startDate: '20260814T140000',
      endDate: '20260815T000000',
    };

    const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&details=${encodeURIComponent(event.details)}&location=${encodeURIComponent(event.location)}&dates=${event.startDate}/${event.endDate}`;
    
    window.open(googleUrl, '_blank');
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
      <button
        onClick={addToGoogleCalendar}
        className="btn-secondary group flex items-center space-x-3"
      >
        <Calendar size={20} />
        <span>Je bloque la date</span>
      </button>

      <button
        onClick={generateICS}
        className="btn-primary group flex items-center space-x-3"
      >
        <Download size={20} />
        <span>Apple / Outlook</span>
      </button>
    </div>
  );
};

export default AddToCalendar;
